import { IRenderingCommonContext } from "@commonRendering/types";
import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { IErrorSectionData } from "src/typings/error-section-data";
import { ErrorSectionRenderer } from "../section/error-section-renderer";

export class ErrorSectionCascadeRenderer extends CascadeRendererBase<IErrorSectionData> {

    protected readonly renderer: ErrorSectionRenderer;

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.renderer = new ErrorSectionRenderer(renderingCommonContext);
    }

    public override createByCascade(data: IErrorSectionData): HTMLElement {
        const element = this.renderer.createNew();
        this.renderer.render(element, data);

        return element;
    }

    public override getDataByCascade(element: HTMLElement): IErrorSectionData | null {
        return this.renderer.getData(element) as IErrorSectionData;
    }

}
